<template>
  <div class="header-box">
    <div class="header-content">
      <div class="header-content-left">
        <!-- 首页才有 -->
        <div class="logo ml5" style="margin-left: 16px;margin-top: 6px;">
          <img @click="to5ce" src="../../../src/assets/image/aiedit-logo.png" />
          <div>
            <p class="beta"></p>
          </div>
        </div>
        <div class=" ml20" style="margin-left: 40px">
          <ul>
            <li
              class="cursor"
              :class="[
                selectColumn1 !== '/folder' &&
                selectColumn1 !== '/materialcollection' &&
                selectColumn1 !== '/recycle'
                  ? 'active'
                  : ''
              ]"
              @click="to('/')"
            >
              首页
            </li>
            <li
              class="cursor"
              :class="[selectColumn2 === '/folder' ? 'active' : '']"
              @click="to('/folder')"
            >
              文集管理
            </li>
            <li
              class="cursor"
              :class="[selectColumn3 === '/materialcollection' ? 'active' : '']"
              @click="to('/materialcollection')"
            >
              收藏管理
            </li>
            <li class="cursor" @click="jumpUrl('traffic/zhihu')">
              知乎引流
            </li>
            <li class="cursor" @click="jumpUrl('traffic/keywordchance')">
              商机挖掘
            </li>
            <li class="cursor" @click="jumpUrl('traffic/keywordhot')">
              全网热词
            </li>
            <li class="cursor" @click="jumpUrl('traffichot')">
              暴涨流量词
            </li>
           
             <tool></tool>
            
          </ul>
        </div>
      </div>
      
     

      <div class="header-content-right">
        <div v-if="false">
          <!-- 首页才有 -->
          <div class="search-box" v-if="isHome">
            <el-input
              size="mini"
              placeholder="请输入您想写的文章"
              v-model="keyword"
              prefix-icon="el-icon-search"
              @keyup.enter.native="search"
            >
            </el-input>
            <el-button class="search-button" size="small" @click="search"
              >搜索</el-button
            >
          </div>
          <div
            @click="createArticle('/material')"
            class="new-article cursor ml20"
          >
            <span class="iconfont">&#xe607;</span> 新建文章
          </div>
          <div class="import-article cursor ml10" v-if="!isHome">
            <span class="iconfont">&#xe607;</span>

            <el-dropdown
              size="mini"
              type="primary"
              placement="bottom-start"
              :hide-on-click="false"
              @command="importSelect"
              class="import-dropdown"
            >
              <span class="el-dropdown-link">导入文章</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, itemIndex) of importList"
                  :key="itemIndex"
                  :command="item.id"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="ml10 cursor radius" @click="preview" v-if="!isHome">
            手机预览
          </div>

          <div class="ml10 cursor radius" @click="save" v-if="!isHome">
            保存文章
          </div>
        </div>
        <div class="ml20 cursor rightLabel">
          <a
            style="font-size: 12px;color: #fff;"
            :href="
              token !== ''
                ? vipUrl + '/act/5ce&code=' + token
                : noLoginVip + '/act/5ce'
            "
            target="_blank"
            >功能介绍</a
          >
        </div>
        <div class="ml20 cursor rightLabel">
          <a
            style="font-size: 12px;color: #fff;"
            :href="
              token !== ''
                ? vipUrl + '/price&code=' + token
                : noLoginVip + '/price'
            "
            target="_blank"
            >会员特权</a
          >
        </div>
        <div class="ml10 mr5 cursor rightLabel kefuInfo">
          <!-- <span
            class="btn"
            @mouseenter="kefuShow = true"
            @mouseleave="kefuShow = false"
          >
            客服微信
          </span>
          <div class="tip" v-if="kefuShow">
            <img src="../../assets/image/vip/code-3.4bddae2.jpg" />
            <p>扫码微信客服咨询</p>
          </div> -->
        </div>
        <!--        <div class="ml10 cursor radius" @click="savePic" v-if="!isHome">-->
        <!--          分享长图-->
        <!--        </div>-->
        <!--        <div class="ml20 mr20 cursor">帮助</div>-->
        <div
          class="head-image-box cursor mr20"
          @mouseenter="userSeting = true"
          @mouseleave="userSetingOut"
          v-if="isShowLogin"
        >
          <el-avatar
            :size="30"
            :src="
              avatarUrl ? avatarUrl : '//thumb.5ce.com/images/icon-face.png'
            "
          >
          </el-avatar>
          <span class="iconfont arrow ml5">&#xe6bb;</span>

          <!--          <el-dropdown>-->
          <!--            <el-avatar-->
          <!--              :size="30"-->
          <!--              :src="-->
          <!--                avatarUrl ? avatarUrl : '//thumb.5ce.com/images/icon-face.png'-->
          <!--              "-->
          <!--            >-->
          <!--            </el-avatar>-->
          <!--            <el-dropdown-menu slot="dropdown">-->
          <!--              <a :href="settingUrl" target="_blank" style="color:#606266">-->
          <!--                <el-dropdown-item icon="el-icon-setting">-->
          <!--                  设置-->
          <!--                </el-dropdown-item>-->
          <!--              </a>-->
          <!--              <a :href="settingUrl" target="_blank" style="color:#606266">-->
          <!--                <el-dropdown-item icon="new-user">-->
          <!--                  新手手册-->
          <!--                </el-dropdown-item>-->
          <!--              </a>-->
          <!--              <el-dropdown-item icon="el-icon-switch-button">-->
          <!--                <a :href="logout" style="color:#606266">退出</a>-->
          <!--              </el-dropdown-item>-->
          <!--            </el-dropdown-menu>-->
          <!--          </el-dropdown>-->
          <!--          <el-dropdown>-->
          <!--            <span class="iconfont arrow ml5">&#xe6bb;</span>-->
          <!--            <el-dropdown-menu slot="dropdown">-->
          <!--              <a :href="settingUrl" target="_blank" style="color:#606266">-->
          <!--                <el-dropdown-item icon="el-icon-setting">-->
          <!--                  设置-->
          <!--                </el-dropdown-item>-->
          <!--              </a>-->
          <!--              <el-dropdown-item icon="el-icon-switch-button">-->
          <!--                <a :href="logout" style="color:#606266">退出</a>-->
          <!--              </el-dropdown-item>-->
          <!--            </el-dropdown-menu>-->
          <!--          </el-dropdown>-->
          <i class="icons1" :class="getVips(userGrade)"></i>
        </div>
        <div v-else>
          <div class="mr10 cursor radius login" @click="tologin" v-if="!isHome">
            登录/注册
          </div>
        </div>
      </div>
    </div>
    <SavePicture
      :isSavePic.sync="isSavePic"
      @closeSavePic="closeSavePic"
    ></SavePicture>
    <PhonePreview
      :content="getBody"
      class="getPhonePreview"
      v-if="isPhonePreview"
      @closePhone="closePhone"
    ></PhonePreview>
    <ImportDialog
      style=""
      v-if="isShowLinkImport"
      @closeShowLinkImport="closeShowLinkImport"
    ></ImportDialog>
    <ImportDocDialog
      v-if="isShowDocImport"
      @closeShowDocImport="closeShowDocImport"
    ></ImportDocDialog>
    <!--    <div>-->
    <!--      <addReff></addReff>-->
    <!--    </div>-->
    <UserSeting :user-seting="userSeting" @userenter="userenter"></UserSeting>
    <!--    <sendPostMsg></sendPostMsg>-->
    <pushmessagedialog
      v-if="pushcontent"
      :content="pushcontent"
    ></pushmessagedialog>
    <!-- 倒计时弹窗 -->
    <countdown :data="countdownModel"></countdown>
    <promote
      :realdiscount="limitedTimeResult.Discount"
      :endTime="limitedTimeResult.EndTime"
      :buyType="limitedTimeResult.buyType"
      :vouchers="limitedTimeResult.vouchers"
      v-if="limitedTimeResult.CheckPop == 1"
    ></promote>

    <div class="backtop-wrap-box-wxrobots" v-if="ImportType!=1" style="bottom: 362px;">             
      <div class="applet-wrap">
        <div>5118助手</div>
        <div class="content">
          <div class="pop">
            <div class="patch_4">
              <img src="http://img01.5118img.com/webmaster/5118-assist.png" class="img" />
              <div class="title">5118助手</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="backtop-wrap-box-ranking222" v-if="ImportType!=1" style=" bottom: 287px;">
      <a class="process-wrap222" href="https://work.weixin.qq.com/kfid/kfcefe337aa26b7921b" target="_blank">
        <div>联系客服</div>
      </a>
    </div>

    <div class="backtop-wrap-box-ranking-txc" style=" bottom: 212px;">
      <a class="process-wrap-txc" href="https://txc.qq.com/products/619573#label=default" target="_blank">
        <div>需求反馈</div>
      </a>
    </div>

    <!-- <a class="backtop-wrap-box_new"  href="https://work.weixin.qq.com/kfid/kfcefe337aa26b7921b" target="_blank"></a> -->

  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { saveDoc } from "../../assets/script/model";
import config from "../../assets/script/config/index.js";
import tinymce from "tinymce";
import Cookies from "js-cookie";
import ImportDialog from "../share/ImportDialog";
import ImportDocDialog from "../share/ImportDocDialog";
import PhonePreview from "../styles/PhonePreview";
import SavePicture from "../styles/SavePicture";
import findWords from "../../assets/script/utils/findWords";
// import addReff from "../../views/addReff";
import UserSeting from "./UserSeting";
// import sendPostMsg from "./sendPostMsg";
import pushmessagedialog from "@/components/dialogs/pushMessage_dialog";
import promote from "@/components/dialogs/Promote_dialog";
import countdown from "@/components/dialogs/countdown_dialog";
import tool from "../share/Intelligence_tool";

export default {
  props: ["isHome"],
  components: {
    ImportDialog,
    ImportDocDialog,
    PhonePreview,
    SavePicture,
    // addReff,
    UserSeting,
    pushmessagedialog,
    promote,
    countdown,
    tool
    // sendPostMsg
  },
  data() {
    return {
      keyword: "",
      settingUrl: config.settingUrl,
      avatarUrl: "",
      logout: config.logout,
      vipUrl: config.indexVipUrl,
      noLoginVip: config.vipUrl,
      jumpHotUrl: config.sucaiUrl,
      index_url: "//" + document.location.host,
      soUrl: config.so5118Url,
      wycUrl: config.wyc5118Url,
      isShowLogin: false,
      isSavePic: false,
      userGrade: 2,
      isShowLinkImport: false,
      isShowDocImport: false,
      isPhonePreview: false,
      returnurl: window.location.href,
      getBody: "",
      kefuShow: false,
      importList: [
        { name: "文件导入", id: 1 },
        { name: "链接导入", id: 2 }
      ],
      selectColumn1: this.$route.path,
      selectColumn2: this.$route.path,
      selectColumn3: this.$route.path,
      userSeting: false,
      userSetintSate: false,
      token: "",
      pushcontent: "",
      limitedTimeResult: {
        CheckPop: 0,
        Discount: 10,
        EndTime: "",
        buyType: 1,
        vouchers:[]
      },
      countdownModel: null
    };
  },
  created() {
    this.getCountDown();
  },
  watch: {
    headerFun: {
      handler(val) {
        if (val === 1) {
          this.setHeaderFun(0);
          if (this.isShowLogin) {
            // this.save();
            this.createArticle("/material");

            // let routerJump = this.$router.resolve({ path: "/folder" });
            // window.open(routerJump.href);
          } else {
            this.insertConfig.showLoginMessage(
              true,
              "您当前账号暂未登录，请登录账号享更多权限",
              "save"
            );
          }
          // this.$router.push("/folder");
        }
        if (val === 3) {
          this.preview();
        }
        if (val === 4) {
          this.save();
        }
        if (val === 5) {
          this.savePic();
        }
      }
    },
    importFile: {
      handler(val) {
        this.importSelect(val);
      }
    }
  },
  computed: {
    ...mapState("home", ["folderId", "backUrl"]),
    ...mapState("user", ["userinfo", "giftInfo"]),
    ...mapState("contents", [
      "showLoginDialogs",
      "headerFun",
      "importFile",
      "showGift",
      "giftTime"
    ]),
    insertDoc: {
      get() {
        return this.$store.state.editorControl.insertDoc;
      },
      set(val) {
        this.$store.state.editorControl.insertDoc = val;
      }
    },
    getTitle: {
      get() {
        return this.$store.state.wycContent.getTitle;
      },
      set(val) {
        this.$store.state.wycContent.getTitle = val;
      }
    },
    docUpdate: {
      get() {
        return this.$store.state.material.docUpdate;
      },
      set(val) {
        this.$store.state.material.docUpdate = val;
      }
    }
  },
  methods: {
    ...mapActions("editorControl", ["ADocInsert"]),
    ...mapActions("user", [
      "getAiUserInfo",
      "getReffInfo",
      "getRegisterGiveRule",
      "getRegisterGive",
      "getUsersVisitDay",
      "AGetPushMessage",
      "AgetLimitedTime",
      "AGetCountDown"
    ]),
    ...mapMutations("user", ["setUserInfo", "setUserLevel", "setGiftInfo"]),
    ...mapMutations("contents", [
      "setShowLoginDialogs",
      "setHeaderFun",
      "setImportFile",
      "setShowGift",
      "setUseGift",
      "setGiftTime"
    ]),
    async createArticle(url) {
      this.setHeaderFun(0);
      if (!this.isHome) {
        if (this.getTitle !== "") {
          if (this.isShowLogin) {
            await this.save();
          }
        }
        tinymce.activeEditor.setContent("");
        this.getTitle = "";
        tinymce.activeEditor.focus();
      }
      this.setSessionDocId("");
      this.insertDoc = new saveDoc();
      this.setLastEditContent(this.insertDoc);
      // let allPath = this.$route.fullPath;
      // if (
      //   allPath.indexOf("/material") === -1 &&
      //   allPath.indexOf("/article/detail") === -1
      // )
      if (url === "9999999999999999999999999") this.$router.push(url);
    },
    async getCountDown() {
      //倒计时弹窗
      var isShowDialog = Cookies.get("isShowCountDownDialog") || "";
      // var isShowDialog = Cookie.get("isShowCountDownDialog") || "";

      var result = await this.AGetCountDown({
        isShowDialog: isShowDialog
      });

      if (result.errorCode == 0) {
        this.countdownModel = result.data;
      }
    },
    to(url) {
      if (this.isShowLogin) {
        if (url === "/") {
          this.$router.push(url);
          this.selectColumn = "";
        } else {
          this.selectColumn = url.replace("/", "");
          let routerJump = this.$router.resolve({ path: url });
          window.open(routerJump.href);
        }
      } else {
        this.setShowLoginDialogs(true);
      }
    },
    jumpUrl(url) {
      // if(url=='aiimage'){
      //   window.open(config.www+"/aips");
      //   return
      // }
       if(url=='ad'){
        window.open(config.www+"/copywriting");
        return
      }
      let returnl = config.yx5118Url.format(url);
      window.open(returnl);
    },
    getVips(type) {
      let r = "";
      if (type === "200") {
        r = "gradeqiye";
      } else if (type === "150") {
        r = "gradezhuanye";
      } else if (type === "100") {
        r = "gradeSvip";
      } else if (type === "6") {
        r = "gradeVip";
      } else if (type === "170") {
        r = "ultimate";
      } else if (type === "50") {
        r = "basics";
      } else {
        r = "gradeNoVip";
      }
      return r;
    },
    toBack() {
      this.$router.push(this.backUrl);
    },
    tologin() {
      this.setShowLoginDialogs(true);
      // window.open(
      //   config.loginUrl +
      //     "?returnUrl=" +
      //     window.location.href +
      //     "&btn=editLogin"
      // );
      // window.location.href =
      //   config.loginUrl + "?returnUrl=" + window.location.href;
    },
    search() {
      this.$router.push("/material/new/" + this.keyword);
    },
    preview() {
      this.setHeaderFun(0);
      let dom = tinymce.activeEditor.getBody();
      let imgs = dom.getElementsByTagName("img");
      for (let img of imgs) {
        img.parentNode.style.height = "auto";
        img.removeAttribute("width");
        img.removeAttribute("height");
      }
      this.getBody = dom.innerHTML;
      this.isPhonePreview = true;
    },
    closePhone() {
      this.isPhonePreview = false;
    },
    savePic() {
      this.setHeaderFun(0);
      this.isSavePic = true;
    },
    closeSavePic() {
      this.isSavePic = false;
    },
    async save() {
      this.setHeaderFun(0);
      findWords.closeAllHighlight();
      if (this.getTitle === "") {
        this.$message({
          message: "标题不能为空",
          showClose: true,
          type: "error"
        });
        return;
      }
      const getArticle = localStorage.getItem("lastEditorContent");
      if (getArticle) {
        this.insertDoc = JSON.parse(getArticle);
        if (this.insertDoc.title === "") {
          this.$message({
            message: "标题不能为空",
            showClose: true,
            type: "error"
          });
          return;
        }
        // if (this.insertDoc.content === "") {
        //   this.$message({
        //     message: "详细内容不能为空",
        //     showClose: true,
        //     type: "error"
        //   });
        //   return;
        // }

        let getTxt = tinymce.activeEditor.getBody().innerText;
        this.insertDoc.intro = getTxt.substring(0, 100).replace(/\s*/gi, "");
        this.insertDoc.folderId = this.folderId;
        // if (this.getSessionDocId() !== 0 && this.getSessionDocId() !== "")
        this.insertDoc.docId = this.getSessionDocId();
        this.insertDoc.title = this.getTitle;
        this.insertDoc.content = tinymce.activeEditor.getBody().innerHTML;
        let result = await this.ADocInsert(this.insertDoc);
        if (result.errorCode === 0) {
          this.docUpdate = true;
          this.insertDoc.docId = result.data;
          this.setSessionDocId(result.data);
          this.setLastEditContent(this.insertDoc);
          this.$message({
            dangerouslyUseHTMLString: true,
            message: `文章已成功保存，可点击 <a href="/folder" target="_blank">“文集管理”</a> 菜单查看`,
            showClose: true,
            iconClass: "no"
          });
        } else {
          if (result.errorCode === 300000) {
            this.insertConfig.showLoginMessage(
              true,
              "您当前账号暂未登录，请登录账号享更多权限",
              "save"
            );
          } else if (result.errorCode === 2008141157) {
            this.docUpdate = true;
            this.$message({
              dangerouslyUseHTMLString: true,
              message: `该文章无法保存，当前文章已经在文集中被删除，您可以在<a href="/recycle" target="_blank">“回收站”</a>找到`,
              showClose: true,
              iconClass: "no"
            });
          } else {
            this.$message({
              showClose: true,
              message: result.errorMess,
              type: "error"
            });
          }
        }
      } else {
        this.$message({
          message: "保存内容出现异常",
          showClose: true,
          type: "error"
        });
      }
    },
    to5ce() {
      window.open(config.sucaiUrl, "_self");
    },
    userSetingOut() {
      this.userSetintSate = false;
      if (!this.userSetintSate) {
        this.userSeting = false;
      }
    },
    userenter(val) {
      this.userSeting = val;
      if (val) {
        this.userSetintSate = val;
      }
    },
    importSelect(id) {
      this.setImportFile(0);
      if (id === 1) {
        this.isShowDocImport = true;
      } else if (id === 2) {
        this.isShowLinkImport = true;
      }
    },
    closeShowLinkImport() {
      this.isShowLinkImport = false;
    },
    closeShowDocImport() {
      this.isShowDocImport = false;
    },
    async userRule() {
      let gettype = this.$route.query.userGiftType;
      let getGiftType = this.$route.query.partyPack;
      let source = this.$route.query.source;

      if (gettype === "1") {
        this.setShowGift(true);
        this.insertConfig.setGiftCookies(0);
      } else if (gettype === "2" && getGiftType === "999") {
        let dataInfo = { givesource: source, days: 30 };
        this.setGiftInfo(dataInfo);
        this.setShowGift(true);
        this.insertConfig.setGiftCookies(0, 999);
      } else {
        let userGift = JSON.parse(Cookies.get("UserGift") || "{}") || {};
        if (Object.keys(userGift).length > 0) {
          let daysTime = userGift.showBox;
          if (userGift.isTake !== 2) {
            if (userGift.isTake === 1) {
              if (this.isShowLogin) {
                if (this.userGrade < 6) {
                  let result = await this.getRegisterGive();
                  if (result.success) {
                    this.setGiftTime(result.data.endTime);
                    this.insertConfig.setGiftCookies(2);
                    this.setUseGift(false);
                  } else {
                    this.$message({
                      showClose: true,
                      message: result.errorMess,
                      type: "error"
                    });
                  }
                } else {
                  // console.log("非新手户不能领取");
                  this.insertConfig.setGiftCookies(0);
                }
              }
            } else {
              if (this.bjDate(this.insertConfig.getDayTime(), daysTime)) {
                this.setShowGift(true);
                this.insertConfig.setGiftCookies(0);
              }
            }
          }
          // else {
          //   console.log("已领取");
          // }
        } else {
          this.setShowGift(true);
          this.insertConfig.setGiftCookies(0);
        }
      }
    },
    async getGiveRule() {
      let result = await this.getRegisterGiveRule();
      if (result.data > 0) {
        this.userRule();
      } else {
        // console.log("不能领取");
        let userGift = JSON.parse(Cookies.get("UserGift") || "{}") || {};
        if (Object.keys(userGift).length > 0) {
          if (userGift.isTake === 1) {
            this.insertConfig.setGiftCookies(0);
          }
        }
      }
    },
    async getUserBackCookies() {
      let userBack = JSON.parse(Cookies.get("userBack") || "{}") || {};
      if (Object.keys(userBack).length > 0) {
        let daysTime = userBack.userTime;
        if (this.bjDate(this.insertConfig.getDayTime(), daysTime)) {
          let data = { userTime: this.insertConfig.getDayTime() };
          this.insertConfig.setUserCookies("userBack", data, 30);
          let result = await this.getUsersVisitDay();
          if (result.ErrorCode === 0) {
            console.log("go back");
          }
        }
      } else {
        let data = { userTime: this.insertConfig.getDayTime() };
        this.insertConfig.setUserCookies("userBack", data, 30);
        let result = await this.getUsersVisitDay();
        console.log(result);
        if (result.ErrorCode === 0) {
          console.log("go back");
        }
      }
    }
  },
  async mounted() {
    let user = JSON.parse(Cookies.get("5ceinfo") || "{}") || {};
    if (Object.keys(user).length > 0) {
      this.setUserInfo(user.token);
      this.token = user.token;
      this.setUserLevel(user.level);
      this.avatarUrl = user.avatar || "";
      this.userGrade = user.level || "";
      this.isShowLogin = true;
      // this.getGiveRule();
      this.getUserBackCookies();
    } else {
      // this.userRule();
    }
    try {
      var result = await this.AGetPushMessage();
      if (
        result.data &&
        result.data.popUpState == 1 &&
        result.data.showStyle == "PopUpHtml"
      ) {
        this.pushcontent = result.data.content.replace(
          '.remove()" style="',
          '.remove()" style="position: absolute;cursor: pointer;'
        );
      }
    } catch (ex) {
      console.log(ex);
    }
    try {
      var limitedTimeResult = await this.AgetLimitedTime();
      if (limitedTimeResult.errorCode == 0) {
        this.limitedTimeResult.CheckPop = limitedTimeResult.data.checkPop;
        this.limitedTimeResult.Discount = limitedTimeResult.data.discount;
        this.limitedTimeResult.EndTime = limitedTimeResult.data.endTime;
        this.limitedTimeResult.buyType = 1;
        this.limitedTimeResult.vouchers = limitedTimeResult.data.vouchers;
      }
    } catch (ex) {
      console.log(ex);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";

.getPhonePreview {
  /deep/.el-dialog {
    background: #fff0;
    border: 0;
  }
}
.icons1 {
  display: inline-block;
  height: 16px;
  width: 16px;
  position: absolute;
  margin-left: 20px;
  margin-top: 15px;
}
.grade {
  vertical-align: sub;
  margin-right: 3px;
  background-size: 16px 16px;
}
.gradeNoVip {
  background: url("../../assets/image/vip/FREE_16.png") no-repeat 50%;
  .grade();
}
.gradeVip {
  background: url("../../assets/image/vip/VIP_16.png") no-repeat 50%;
  .grade();
}
.gradeSvip {
  background: url("../../assets/image/vip/SVIP_16.png") no-repeat 50%;
  .grade();
}
.gradezhuanye {
  background: url("../../assets/image/vip/zhuanye_16.png") no-repeat 50%;
  .grade();
}
.ultimate {
  background: url("../../assets/image/vip/ultimate-16.png") no-repeat 50%;
  .grade();
}
.basics {
  background: url("../../assets/image/vip/basics_16.png") no-repeat 50%;
  .grade();
}
.gradeqiye {
  background: url("../../assets/image/vip/qiye_16.png") no-repeat 50%;
  .grade();
}

.icons {
  display: inline-block;
  height: 24px;
  width: 21px;
  margin-left: 5px;
}
.editLeft {
  background: url("../../assets/image/edit_Left.png") no-repeat 50%;
  vertical-align: sub;
  margin-right: 3px;
}

.header-box {
  background-color: @theme-color;
  height: 60px;

  color: white;
}
.header-content {
  height: 60px;
}
.header-content {
  display: flex;
  justify-content: space-between;
}
.header-content .logo {
  cursor: pointer;
}

.gradeUrl {
}
.header-content-left {
  display: flex;
  align-items: center;
  .beta {
    position: absolute;
    margin-top: -45px;
    margin-left: 155px;
    font-size: 12px;
  }
}
//右边
.header-content-right {
  display: flex;
  align-items: center;
  .login {
    background-color: #ff840c !important;
    border: 1px solid #ff840c;
  }
  .rightLabel {
    margin-top: -3px;
  }
  .kefuInfo {
    position: relative;
    .btn {
      font-size: 12px;
      color: #fff;
    }
    .tip {
      position: absolute;
      z-index: 99;
      top: 40px;
      left: -20px;
      width: 130px;
      height: 160px;
      padding: 5px;
      border-radius: 3px;
      border: 1px solid #dcdcdc;
      background-color: #fff;
      /*background-image: url("../../assets/image/vip/code-3.4bddae2.jpg");*/
      /*background-repeat: no-repeat;*/
      p {
        color: #666;
        text-align: center;
        font-size: 14px;
      }
      &:before {
        content: "";
        position: absolute;
        top: -6px;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        left: calc(50% - 5px);
        border-left: 1px solid #eee;
        border-top: 1px solid #eee;
        background-color: #fff;
      }
    }
  }
}
.header-content-right .new-article {
  border: 1px solid white;
  border-radius: 15px;
  padding: 5px 8px;
  font-size: 12px;
}
.header-content-right .new-article .iconfont {
  font-size: 12px;
}
.header-content-right .import-article {
  border: 1px solid white;
  border-radius: 15px;
  padding: 5px 8px;
  font-size: 12px;
}
.header-content-right .import-article .iconfont {
  font-size: 12px;
}
.search-box {
  display: flex;
  width: 240px;
}
.search-box .search-button {
  padding: 5px 15px;
  background-color: #89aefc;
  color: white;
  border-radius: 0 15px 15px 0;
  border: none;
}
.head-image-box {
  display: flex;
  align-items: center;
  height: 90px;
  .new-user {
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    &:before {
      content: "\e60d";
    }
  }
}
.head-image-box .arrow {
  vertical-align: middle;
}

.header-content-right .arrow {
  color: white;
  font-size: 9px;
}
.icon-head-down {
  content: "";
  z-index: 2;
  border: 4px solid transparent;
  border-top: 4px solid white;
  position: absolute;
  top: 50%;
  right: -12px;
}

.header-content-right .radius {
  background-color: #588dfd;
  padding: 6px 15px;
  border-radius: 15px;
  cursor: pointer;
  font-size: 12px;
}
.header-content-left .left-arrow {
  font-size: 20px;
}
.header-content-left .cloud {
  font-size: 20px;
}
// .header-content-left {
//   display: flex;
// }
// .header-content-left .logo {
//   cursor: pointer;
//   img {
//     align-items: center;
//   }
// }

// .header-box ul {
//   line-height: 60px;
// }

.header-box ul li {
  color: #e3e5ec;
  float: left;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  margin-left: 20px;
  line-height: 58px;
  &:hover {
    color: #fff;
  }
  a {
    color: #e3e5ec;
    &:hover {
      color: #fff;
    }
  }
}
.header-box ul li:first-child {
  margin-left: 10px;
}

.header-box ul li.active {
  border-bottom: 2px solid white;
  color: white;
}
.header-content-right {
  font-size: 14px;
}
.document-dialog {
  .login-tip {
    text-align: center;
    margin: 20px 0;
  }
  .dialog-tologin {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 8px 20px;
  }
  .dialog-document .dialog-title {
    font-size: 14px;
  }
}
.el-dropdown-link {
  color: white !important;
  font-size: 12px;
  padding: 2px 0;
}
</style>
<style lang="less">
.el-pager li:not(.disabled).active {
  background-color: #1059f6 !important;
}
.headerTip.el-tooltip__popper.is-dark {
  background-color: #303133 !important;
}

.header-content-right .search-box .el-input__inner {
  height: 24px;
  line-height: 24px;

  background-color: #568af8;
  color: white;
  border: none;
  border-radius: 15px 0 0 15px;
}
.header-content-right .search-box .el-input__inner::placeholder {
  color: #eaecfb;
}
.header-content-right .search-box .el-input--mini .el-input__icon {
  color: #eaecfb;
}
.is-closable {
  background-color: #ffffff;
  color: #666;
  border-radius: 20px;
  a {
    color: #1c5af4;
  }
}

.backtop-wrap-box-wxrobots {
    position: fixed;
    right: 10px;
    bottom: 362px;
    z-index: 5555;
    background: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.08);
    border-radius: 8px;   

 .applet-wrap {
        position: relative;
        width: 65px;
        height: 70px;
        background: url("../../assets/image/5118.png") no-repeat center 15px;
        line-height: 70px;
        padding-top: 15px;
        padding-bottom: 15px;
        color: #0c7df5;
        font-family: "微软雅黑";
        text-align: center;
        font-size: 13px;
        display: inline-block;
        text-decoration: none;        

        > .content {
            display: none;
            position: absolute;
            right: 75px;
            bottom: -61px;
            padding-right: 23px;
            width: 170px;
            background-color: transparent;

            > .pop {
                width: 170px;
                background: #ffffff;
                border-radius: 8px;
                box-shadow: 0px 0px 40px 0px rgba(0,0,0,0.08);

                .patch_4, .patch_3 {
                    padding: 5px;
                    height: auto;

                    &::before {
                        content: "";
                        display: block;
                        position: absolute;
                        border-left: 0;
                        z-index: 2;
                        bottom: 87px;
                        right: -18px;
                        border: 10px solid transparent;
                        border-left: 10px solid #fff;
                    }

                    .title {
                        height: 32px;
                        line-height: 32px;
                        font-size: 13px;
                        color: #666;
                        width: auto;
                        margin: 0;
                    }

                    .img {
                        width: 120px;
                        margin-bottom: 4px;
                        vertical-align: middle;
                    }
                }             
            }
        }

        &:hover,
        &.active {
            background: url("../../assets/image/5118_xz.png") #0c7df5 no-repeat center 15px;
            display: block;
            border-radius: 8px;
            box-shadow: 2px 3.46px 12px 4px rgba(11,125,245,0.50);
            color: #fff;

            > .content {
                display: block;
            }
        }
    }
}


.backtop-wrap-box-ranking222 {
    position: fixed;
    right: 10px;
    bottom: 362px;
    z-index: 5555;
    background: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.08);
    border-radius: 8px;   

 .process-wrap222 {
        position: relative;
        width: 65px;
        height: 70px;
        background: url("../../assets/image/img_ls.png") no-repeat center 15px;
        line-height: 70px;
        padding-top: 15px;
        padding-bottom: 15px;
        color: #0c7df5;
        font-family: "微软雅黑";
        text-align: center;
        font-size: 13px;
        display: inline-block;
        text-decoration: none;        

        &:hover,
        &.active {
            background: url("../../assets/image/img_bs.png") #0c7df5 no-repeat center 15px;
            display: block;
            border-radius: 8px;
            box-shadow: 2px 3.46px 12px 4px rgba(11,125,245,0.50);
            color: #fff;

            > .content {
                display: block;
            }
        }
    }
}

.backtop-wrap-box-ranking-txc {
    position: fixed;
    right: 10px;
    bottom: 213px;
    z-index: 5555;
    background: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.08);
    border-radius: 8px;

    .process-wrap-txc {
        position: relative;
        width: 65px;
        height: 70px;
        background: url("../../assets/image/txc.png") no-repeat center 15px;
        line-height: 70px;
        padding-top: 15px;
        padding-bottom: 15px;
        color: #0c7df5;
        font-family: "微软雅黑";
        text-align: center;
        font-size: 13px;
        display: inline-block;
        text-decoration: none;       

        &:hover,
        &.active {
            background: url("../../assets/image/txc_bs.png") #0c7df5 no-repeat center 15px;
            display: block;
            border-radius: 8px;
            box-shadow: 2px 3.46px 12px 4px rgba(11,125,245,0.50);
            color: #fff;

            > .content {
                display: block;
            }
        }
    }
}


 .backtop-wrap-box_new {
          position: fixed;
          right: 10px;
          bottom: 40px;
          z-index: 5555;
          background: url("../../assets/image/weixin.png") no-repeat;
          width:142px;
          height:66px;
}
 .backtop-wrap-box_new:hover {
      position: fixed;
      right: 10px;
      bottom: 40px;
      z-index: 5555;
      width:142px;
      height:66px;
      background: url("../../assets/image/weixin_hover.png") center center no-repeat;
}


</style>
